/*!
* Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
* The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
*
* You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
* WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
*
* See the License for the specific language governing permissions and limitations under the License.
*/

<template>
  <div id="login" class="container">
    <div class="row">
      <div class="col-md-offset-4 col-md-4">
        <div class="form-horizontal">
          <h1>Tourbillon</h1>
          <div>
            <button id="login-button" class="ui btn btn-primary" role="button" v-on:click="login()">
              Login with Okta
            </button>
          </div>
          <div v-show="error_message" id="error-message"
               class="alert alert-danger" role="alert">
            Error: {{ error_message }}
          </div>
          <div v-show="info_message" id="info-message"
               class="alert alert-info" role="alert">
            {{ info_message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  mounted: async function () {
    const authenticated = await this.$auth.isAuthenticated();
    if (!authenticated) {
      this.$auth.signInWithRedirect({
        originalUri: '/'
      });
    }
  },
  methods: {
    login() {
      this.$auth.signInWithRedirect({originalUri: '/'})
    },

  }
}
</script>
